import React, { FC } from 'react';
import BaseWarningModal from './BaseWarningModal';

type AvailabilityModalProps = {
  open: boolean;
  onClose: () => void;
  onClick: () => void;
};

const AvailabilityModal: FC<AvailabilityModalProps> = ({
  open,
  onClose,
  onClick,
}) => {
  return (
    <BaseWarningModal
      open={open}
      onClose={onClose}
      onClick={onClick}
      title="modal.availability.title"
      description="modal.availability.description"
      button="modal.availability.button"
    />
  );
};

export default AvailabilityModal;
